import Vue from 'vue'
import VueRouter from 'vue-router'
import ServiceList from "../views/ServiceList";
import AntiCoronavirus from "../views/AntiCoronavirus";
import PerInforation from "../views/PerInforation";
import Register from "../views/Register";
import MyTaxiInfo from "../views/MyTaxiInfo";
import MyTaxi from "../views/MyTaxi";
import MaskInfo from "../views/MaskInfo";
import TaxiOrder from "../views/TaxiOrder";
import TaxiOrderInfo from "../views/OrderInfo";
import Epidemic from "../views/Epidemic";
import {NavBar} from 'vant';
import {Icon} from 'vant';
import {Button} from 'vant';
import {Tabbar, TabbarItem} from 'vant';
import {Image} from 'vant';
import {Field, Form} from 'vant';
Vue.use(Field, Form);
Vue.use(Image);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Button);
Vue.use(Icon);
Vue.use(NavBar);
Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'ServiceList',
        component: ServiceList,
        meta: {
            title: "我的服务"
        },
        props: (route) => ({accessToken: route.query.accessToken})
        // 入口示例：http://localhost:8080/#/?token=eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIwODBjMWQwNS0xNTM4LTRhNzUtYmE0Ni0wYTMxYTkzOGEyOGQifQ.6DLKjs8j-6-wzdCbBvOzR0agKqwRbxtwa1jnujIubWUm52vkifCgffnlomNPL6K4l-0Jy_BGy_fNjLOXKkx4Qg
    },
    {
        path: '/anti-coronavirus',
        name: 'anti-coronavirus',
        meta: {
            title: "我的抗疫"
        },
        component: AntiCoronavirus
    },
    {
        path: '/my-taxi',
        name: 'my-taxi',
        meta: {
            title: "我的出行"
        },
        component: MyTaxi
    },
    {
        path: '/per-information',
        name: 'per-information',
        meta: {
            title: "我的信息"
        },
        component: PerInforation
    },
    {
        path: '/register',
        name: 'register',
        meta: {
            title: "信息填写"
        },
        component: Register
    },
    {
        path: '/my-taxi-info',
        name: 'my-taxi-info',
        meta: {
            title: "出行详情"
        },
        component: MyTaxiInfo
    },
    {
        path: '/mask-info',
        name: 'mask-info',
        meta: {
            title: '口罩申领'
        },
        component: MaskInfo
    },
    {
        path: '/taxi-order',
        name: 'taxi-order',
        meta: {
            title: '订单预约'
        },
        component: TaxiOrder
    },
    {
        path:'/taxi-order-info',
        name:'taxi-order-info',
        meta:{
            title:'订单详情'
        },
        component:TaxiOrderInfo
    },
    {
        path:'/epidemic',
        name:'epidemic',
        meta:{
            title:'实时疫情'
        },
        component:Epidemic
    },
    {
        path: '/error',
        name: 'Error',
        meta: {
            title: "Oops..."
        },
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/Error.vue')
    }
];

const router = new VueRouter({
    routes
});

export default router
